import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { useRouteMatch } from 'react-router';
import { ButtonGroup } from '../../../components';
import { ArrowUp, ExchangeIcon } from '../../../components/icon/solid';
import useStyles from './styles';
import AdjustCreditsModal from './AdjustCredits/AdjustCreditsModal';
import { User } from '../../../types/items';
import { selectCreditList } from '../../../store/modules/credits/selectors';
import TransferCreditsModal from './TransferCredits/TransferCreditsModal';

type Props = {
  user: User;
};

const AdjustmentsButtonGroup = ({ user }: Props) => {
  const classes = useStyles();
  const [openAdjustCredits, setOpenAdjustCredits] = useState(false);
  const [openTransferCredits, setOpenTransferCredits] = useState(false);
  const { dirty } = useSelector(selectCreditList);
  const dispatch = useDispatch();
  const { path } = useRouteMatch();

  useEffect(() => {
    if (dirty) {
      setOpenAdjustCredits(false);
      setOpenTransferCredits(false);
    }
  }, [setOpenTransferCredits, setOpenAdjustCredits, dirty]);

  const buttons = [
    {
      title: 'Adjust Credits',
      onClick: () => setOpenAdjustCredits(true),
      hide: true,
      disabled: false,
      path: [],
    },
    {
      title: <span className={classes.label}><ExchangeIcon className={classes.icon} />Transfer Credits</span>,
      onClick: () => setOpenTransferCredits(true),
      disabled: false,
      path: [],
    },
  ];

  if (user.ref?.active_subscription?.can_upgrade && path.search('billing/plan') !== -1) {
    buttons.push({
      title: <span className={classes.label}><ArrowUp className={classes.icon} />Change Plan</span>,
      onClick: () => dispatch(push('/dashboard/plans/pricing')),
      disabled: false,
      path: [],
    });
  }
  return (
    <>
      <ButtonGroup
        buttons={buttons}
        selectedDefault={() => 0}
        disableUpdateMainButton={false}
      />
      <AdjustCreditsModal
        open={openAdjustCredits}
        closeModalHandler={() => setOpenAdjustCredits(false)}
        user={user}
      />
      <TransferCreditsModal
        open={openTransferCredits}
        closeModalHandler={() => setOpenTransferCredits(false)}
        user={user}
      />
    </>
  );
};

export default AdjustmentsButtonGroup;
